module.exports = __webpack_public_path__ + "static/media/intro.fa6b6f5e.mp3";